<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div style="width:280px">
        <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
      </div>
    </template>
    <template v-slot:right_view>
      <UserTableMenu ref="menuInfo" @methodEnum='methodEnum'></UserTableMenu>
      <UserTable ref="userTable"></UserTable>
    </template>
  </BasicLayout>
</template>

<script>
import UserTable from '../../../../components/subscriberconfig/epcSubscriber/user/UserTable';
import UserTableMenu from '../../../../components/subscriberconfig/epcSubscriber/user/UserTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'UserMainPage',
  components: {
    NeList,
    UserTable,
    UserTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("LteUser.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("LteUser.crumb"),
      },
      netype: [4],
    };
  },
  methods: {
    methodEnum(opcode, params) {
      switch (opcode) {
        case 'add':
          this.$refs.userTable.openAddUserPage();
          break;
        case 'addBatch':
          this.$refs.userTable.openAddBatchUserPage();
          break;
        case 'mod':
          this.$refs.userTable.openModUserPage();
          break;
        case 'del':
          this.$refs.userTable.delUsers();
          break;
        case 'delRange':
          this.$refs.userTable.openDelRangePage();
          break;
        case 'qry':
          // this.$refs.userTable.qryUsers(0, true);
          this.$refs.menuInfo.setSearchString();
          this.$refs.userTable.refreshData();
          break;
        case 'chg':
          this.$refs.userTable.setfilter(params);
          break;
        case 'src':
          this.$refs.userTable.filterData();
          break;
        default:
      }
    },
    neClick(ne) {
      this.$refs.userTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
